"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMarketBooking = exports.PARTIAL_PAYMENT = void 0;
const constants_1 = require("../constants");
const number_1 = require("../number");
exports.PARTIAL_PAYMENT = {
    allowed: true,
    percentage: 30,
    pricingGroup: constants_1.USER_GROUPS.NORMAL,
};
function buildMarketBooking(normalPricing, internetPricing, options, _userGroupId) {
    const toPayFields = () => {
        if (!options.partialPayment) {
            return {
                toPayNow: internetPricing.sum,
            };
        }
        const advanceToPay = Math.floor(number_1.percent(exports.PARTIAL_PAYMENT.percentage, normalPricing.sum));
        return {
            toPayNow: advanceToPay,
            toPayRemaining: normalPricing.sum - advanceToPay,
        };
    };
    return Object.assign(Object.assign({}, toPayFields()), { normalAdvancePercentage: exports.PARTIAL_PAYMENT.percentage, normalPrice: normalPricing, internetPrice: internetPricing, internetPaymentSaving: Math.max(0, normalPricing.sum - internetPricing.sum), internetPaymentChecked: !options.partialPayment, userGroupId: _userGroupId });
}
exports.buildMarketBooking = buildMarketBooking;
//# sourceMappingURL=marketBooking.js.map